import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { BaseCrudService } from '../base-crud.service';

import { AcaoModel } from '../../models/controle-acesso/acao-model';

@Injectable({
  providedIn: 'root'
})
export class AcaoService extends BaseCrudService<AcaoModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'Acao';
  }

  getAll(): Observable<AcaoModel[]> {
    return this
      .httpClient
      .get<AcaoModel>(`${this.getApiUrl()}${this.getController()}`, this.getAuthHeaderJson())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError)
      );
  }
}
